export const LogoutIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_0_18"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <rect width="30" height="30" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_0_18)">
        <path
          d="M6.63469 25.625C6.00327 25.625 5.46881 25.4062 5.03131 24.9687C4.59381 24.5312 4.37506 23.9968 4.37506 23.3653V6.63466C4.37506 6.00324 4.59381 5.46878 5.03131 5.03128C5.46881 4.59378 6.00327 4.37503 6.63469 4.37503H14.0746C14.3406 4.37503 14.5633 4.46478 14.7428 4.64428C14.9223 4.82376 15.0121 5.04651 15.0121 5.31253C15.0121 5.57855 14.9223 5.8013 14.7428 5.98078C14.5633 6.16026 14.3406 6.25 14.0746 6.25H6.63469C6.53852 6.25 6.45036 6.29006 6.37022 6.37019C6.29009 6.45033 6.25003 6.53849 6.25003 6.63466V23.3653C6.25003 23.4615 6.29009 23.5497 6.37022 23.6298C6.45036 23.7099 6.53852 23.75 6.63469 23.75H14.0746C14.3406 23.75 14.5633 23.8397 14.7428 24.0192C14.9223 24.1987 15.0121 24.4214 15.0121 24.6875C15.0121 24.9535 14.9223 25.1762 14.7428 25.3557C14.5633 25.5352 14.3406 25.625 14.0746 25.625H6.63469ZM22.0217 15.9375H12.3077C12.0417 15.9375 11.8189 15.8477 11.6395 15.6683C11.46 15.4888 11.3702 15.266 11.3702 15C11.3702 14.734 11.46 14.5112 11.6395 14.3318C11.8189 14.1523 12.0417 14.0625 12.3077 14.0625H22.0217L19.6178 11.6587C19.4448 11.4856 19.3562 11.2745 19.3522 11.0253C19.3482 10.7761 19.4368 10.5545 19.6178 10.3606C19.7989 10.1667 20.0185 10.0666 20.2765 10.0602C20.5345 10.0537 20.7605 10.1475 20.9544 10.3414L24.8221 14.2092C25.0481 14.4351 25.161 14.6987 25.161 15C25.161 15.3013 25.0481 15.5649 24.8221 15.7908L20.9544 19.6586C20.7685 19.8445 20.5477 19.9362 20.2921 19.9338C20.0365 19.9314 19.8118 19.8333 19.6178 19.6394C19.4368 19.4455 19.3494 19.2227 19.3558 18.9711C19.3623 18.7195 19.456 18.5032 19.6371 18.3221L22.0217 15.9375Z"
          fill="#D53A3A"
        />
      </g>
    </svg>
  );
};
export const SearchIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6725 14.6412L19 19M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z"
        stroke="#666666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RightArrow = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#0075FF" fillOpacity="0.1" />
      <path
        d="M10.5 15H19.5M19.5 15L16.5 12M19.5 15L16.5 18"
        stroke="#0075FF"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickIcon = () => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.10417 7.31246L10.3333 1.08329C10.4849 0.930515 10.6616 0.854126 10.8635 0.854126C11.0656 0.854126 11.2431 0.930515 11.3958 1.08329C11.5486 1.23607 11.625 1.41371 11.625 1.61621C11.625 1.81871 11.5513 1.99364 11.404 2.141L4.64583 8.91663C4.49431 9.0694 4.31757 9.14579 4.11562 9.14579C3.91354 9.14579 3.73611 9.0694 3.58333 8.91663L0.604167 5.93746C0.451389 5.78468 0.375 5.6076 0.375 5.40621C0.375 5.20482 0.451389 5.02774 0.604167 4.87496C0.756944 4.72218 0.935208 4.64579 1.13896 4.64579C1.34257 4.64579 1.51847 4.72218 1.66667 4.87496L4.10417 7.31246Z"
        fill="#0075FF"
      />
    </svg>
  );
};

export const LeftArrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 12H6M6 12L10 8M6 12L10 16"
        stroke="#222222"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DragIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_137_178"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_137_178)">
        <path
          d="M4.16683 12.5C3.93072 12.5 3.7328 12.4201 3.57308 12.2604C3.41336 12.1007 3.3335 11.9028 3.3335 11.6667C3.3335 11.4306 3.41336 11.2326 3.57308 11.0729C3.7328 10.9132 3.93072 10.8333 4.16683 10.8333H15.8335C16.0696 10.8333 16.2675 10.9132 16.4272 11.0729C16.587 11.2326 16.6668 11.4306 16.6668 11.6667C16.6668 11.9028 16.587 12.1007 16.4272 12.2604C16.2675 12.4201 16.0696 12.5 15.8335 12.5H4.16683ZM4.16683 9.16667C3.93072 9.16667 3.7328 9.08681 3.57308 8.92708C3.41336 8.76736 3.3335 8.56944 3.3335 8.33333C3.3335 8.09722 3.41336 7.89931 3.57308 7.73958C3.7328 7.57986 3.93072 7.5 4.16683 7.5H15.8335C16.0696 7.5 16.2675 7.57986 16.4272 7.73958C16.587 7.89931 16.6668 8.09722 16.6668 8.33333C16.6668 8.56944 16.587 8.76736 16.4272 8.92708C16.2675 9.08681 16.0696 9.16667 15.8335 9.16667H4.16683Z"
          fill="#666666"
        />
      </g>
    </svg>
  );
};

export const LeftArrowPagination = () => {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00004 5.00005L5.25004 8.25005C5.40282 8.40283 5.47921 8.59727 5.47921 8.83338C5.47921 9.0695 5.40282 9.26394 5.25004 9.41672C5.09726 9.5695 4.90282 9.64588 4.66671 9.64588C4.4306 9.64588 4.23615 9.5695 4.08337 9.41672L0.250041 5.58338C0.166707 5.50005 0.10768 5.40977 0.0729574 5.31255C0.0382351 5.21533 0.020874 5.11116 0.020874 5.00005C0.020874 4.88894 0.0382351 4.78477 0.0729574 4.68755C0.10768 4.59033 0.166707 4.50005 0.250041 4.41672L4.08337 0.583384C4.23615 0.430606 4.4306 0.354218 4.66671 0.354218C4.90282 0.354218 5.09726 0.430606 5.25004 0.583384C5.40282 0.736162 5.47921 0.930606 5.47921 1.16672C5.47921 1.40283 5.40282 1.59727 5.25004 1.75005L2.00004 5.00005Z"
        fill="#0075FF"
      />
    </svg>
  );
};

export const RightArrowPagination = () => {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.50004 5.00005L0.250041 1.75005C0.0972629 1.59727 0.020874 1.40283 0.020874 1.16672C0.020874 0.930606 0.0972629 0.736162 0.250041 0.583384C0.402818 0.430606 0.597263 0.354218 0.833374 0.354218C1.06949 0.354218 1.26393 0.430606 1.41671 0.583384L5.25004 4.41672C5.33337 4.50005 5.3924 4.59033 5.42712 4.68755C5.46185 4.78477 5.47921 4.88894 5.47921 5.00005C5.47921 5.11116 5.46185 5.21533 5.42712 5.31255C5.3924 5.40977 5.33337 5.50005 5.25004 5.58338L1.41671 9.41672C1.26393 9.5695 1.06949 9.64588 0.833374 9.64588C0.597263 9.64588 0.402818 9.5695 0.250041 9.41672C0.0972629 9.26394 0.020874 9.0695 0.020874 8.83338C0.020874 8.59727 0.0972629 8.40283 0.250041 8.25005L3.50004 5.00005Z"
        fill="#0075FF"
      />
    </svg>
  );
};

export const PlusIcon = ({ width = 14, height = 14 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 12.8333V1.16667"
        stroke="#0075FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16675 7H12.8334"
        stroke="#0075FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Spinner = () => {
  return (
    <svg
      aria-hidden="true"
      className="mr-2 h-5 w-5 animate-spin text-white"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
};

export const BrowseImageIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      <mask
        id="mask0_352_119"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_352_119)">
        <path
          d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H10C10.2361 2.5 10.434 2.57986 10.5938 2.73958C10.7535 2.89931 10.8333 3.09722 10.8333 3.33333C10.8333 3.56944 10.7535 3.76736 10.5938 3.92708C10.434 4.08681 10.2361 4.16667 10 4.16667H4.16667V15.8333H15.8333V10C15.8333 9.76389 15.9132 9.56597 16.0729 9.40625C16.2326 9.24653 16.4306 9.16667 16.6667 9.16667C16.9028 9.16667 17.1007 9.24653 17.2604 9.40625C17.4201 9.56597 17.5 9.76389 17.5 10V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM5 14.1667H15L11.875 10L9.375 13.3333L7.5 10.8333L5 14.1667ZM14.1667 5.83333H13.3333C13.0972 5.83333 12.8993 5.75347 12.7396 5.59375C12.5799 5.43403 12.5 5.23611 12.5 5C12.5 4.76389 12.5799 4.56597 12.7396 4.40625C12.8993 4.24653 13.0972 4.16667 13.3333 4.16667H14.1667V3.33333C14.1667 3.09722 14.2465 2.89931 14.4062 2.73958C14.566 2.57986 14.7639 2.5 15 2.5C15.2361 2.5 15.434 2.57986 15.5938 2.73958C15.7535 2.89931 15.8333 3.09722 15.8333 3.33333V4.16667H16.6667C16.9028 4.16667 17.1007 4.24653 17.2604 4.40625C17.4201 4.56597 17.5 4.76389 17.5 5C17.5 5.23611 17.4201 5.43403 17.2604 5.59375C17.1007 5.75347 16.9028 5.83333 16.6667 5.83333H15.8333V6.66667C15.8333 6.90278 15.7535 7.10069 15.5938 7.26042C15.434 7.42014 15.2361 7.5 15 7.5C14.7639 7.5 14.566 7.42014 14.4062 7.26042C14.2465 7.10069 14.1667 6.90278 14.1667 6.66667V5.83333Z"
          fill="#0075FF"
        />
      </g>
    </svg>
  );
};

// MaleIcon.jsx
export const MaleIcon = ({ color = "#222222", isSelected = false }) => {
  const iconColor = isSelected ? "#0075FF" : color; // Change color if selected
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.3864 23.6024C24.2995 21.1414 21.1784 19.5247 20.4922 19.1731C20.4237 19.1378 20.355 19.0676 20.355 18.9621V16.7124C20.6981 16.0094 20.8698 15.2711 21.0067 14.6032C21.3155 14.8143 21.7958 14.7087 22.3445 12.7405C22.7903 11.1583 22.5159 10.596 22.1386 10.4905C23.3735 4.40915 20.5609 4.19812 20.5609 4.19812C20.5609 4.19812 20.1152 3.35458 18.9832 2.72178C18.2286 2.26524 17.1997 1.91332 15.7934 2.01884C15.3476 2.0542 14.9358 2.12435 14.5243 2.26494C14.0098 2.4406 13.5638 2.68671 13.118 3.00296C12.6035 3.35458 12.1233 3.74128 11.6772 4.23349C10.9916 4.93644 10.3742 5.88549 10.1341 7.0105C9.89392 7.99493 9.89392 9.0492 10.2712 10.1038C9.75674 10.0684 9.17353 10.3499 9.72252 12.3889C10.1341 13.9003 10.5114 14.287 10.8199 14.3223C10.9571 15.1659 11.1972 16.1149 11.7117 16.9935V18.9624C11.7117 19.0676 11.6772 19.138 11.5746 19.1731C10.8887 19.5247 7.76754 21.1417 4.68063 23.6024C4.15739 24.0181 3.73391 24.5509 3.4426 25.1602C3.1513 25.7695 2.9999 26.439 3 27.1175V28.6993C2.99962 28.8702 3.03218 29.0395 3.09581 29.1975C3.15943 29.3554 3.25288 29.4989 3.37077 29.6198C3.48866 29.7407 3.62868 29.8365 3.78279 29.9017C3.9369 29.9669 4.10207 30.0003 4.26882 30H27.7295C27.8962 30.0004 28.0614 29.967 28.2156 29.9018C28.3697 29.8366 28.5098 29.7408 28.6277 29.6199C28.7456 29.499 28.8391 29.3555 28.9027 29.1975C28.9664 29.0395 28.999 28.8702 28.9986 28.6993V27.1175C29.0328 25.7466 28.4496 24.446 27.3864 23.6024Z"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FemaleIcon = ({ color = "#222222", isSelected = false }) => {
  const iconColor = isSelected ? "#0075FF" : color;
  return (
    <svg
      width="28"
      height="30"
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.9929 27.9316C27.0615 28.5004 26.623 29 26.067 29H1.93307C1.37764 29 0.939406 28.5013 1.00687 27.933L1.0083 27.9218C1.07576 27.3604 1.24185 26.8266 1.46283 26.3102C1.72411 25.6986 2.20064 25.2904 2.71949 24.9288C3.66428 24.2697 4.71312 23.8235 5.75881 23.3731C6.51121 23.0495 7.26819 22.7365 8.01801 22.4073C10.1437 21.4208 10.427 20.666 10.4593 20.5475C10.4748 20.4777 10.4859 20.4069 10.4925 20.3356C10.5076 20.1714 10.5196 20.0069 10.5302 19.8422V19.4151C7.68755 19.441 6.08556 18.6738 5.27713 18.0849C4.9541 17.8497 4.97183 17.3634 5.29285 17.1253C6.05783 16.5588 7.15184 14.9292 7.04521 10.2405C6.88284 3.0957 10.0771 1.91586 11.268 1.44841C14.7356 0.0899577 16.4785 2.25128 16.4785 2.25128C20.498 1.86812 21.6075 6.3953 21.1135 11.5518C20.7785 15.0509 21.936 16.5449 22.7144 17.1438C23.0294 17.3861 22.9934 17.878 22.6652 18.1006C20.6407 19.4723 17.5005 19.3729 17.5005 19.3729V20.2492C17.503 20.2775 17.505 20.3064 17.5079 20.335C17.5145 20.4069 17.5256 20.4776 17.5408 20.5469C17.5734 20.6657 17.8564 21.4205 19.9821 22.4067C20.7322 22.7359 21.4891 23.0492 22.2413 23.3726C23.2875 23.8226 24.3358 24.2689 25.2806 24.9279C25.7994 25.2901 26.2762 25.698 26.5375 26.3096C26.7582 26.8254 26.9246 27.3598 26.9921 27.9213L26.9929 27.9316Z"
        stroke={iconColor}
        strokeWidth="2"
      />
    </svg>
  );
};

export const OtherGenderIcon = ({
  color = "#222222",
  isSelected = false,
  width = "30",
  height = "24",
}) => {
  const iconColor = isSelected ? "#0075FF" : color; // Change color if selected
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6407 17.2398C14.64 19.2128 14.4572 20.0284 12.4461 21.1895C9.76461 22.7377 5.17664 22.5318 3.0938 18.9242C0.770448 14.9 1.75538 11.2655 5.47613 9.11728C11.5929 5.58565 17.809 18.0932 24.5126 14.2229C28.679 11.8174 28.803 8.10362 27.2268 4.99098C25.5618 1.70263 21.9314 -0.383149 17.5427 2.15065C14.8612 3.69883 14.6761 4.57216 14.6888 6.48105"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadPhotoIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.3332 20.0001H19.9998M19.9998 20.0001H10.6665M19.9998 20.0001V10.6667M19.9998 20.0001V29.3334"
        stroke="#0075FF"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const SaveIcon = ({ width = "32", height = "32" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3335 28V25.3333C21.3335 22.8192 21.3335 21.5621 20.5524 20.7811C19.7714 20 18.5143 20 16.0002 20H14.6668C12.1527 20 10.8956 20 10.1145 20.7811C9.3335 21.5621 9.3335 22.8192 9.3335 25.3333V28"
        stroke="#0075FF"
        strokeWidth="2"
      />
      <path
        d="M9.3335 10.6665H16.0002"
        stroke="#0075FF"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4H21.5621C22.1071 4 22.3796 4 22.6247 4.10149C22.8696 4.20299 23.0624 4.39568 23.4477 4.78105L27.2189 8.55228C27.6043 8.93765 27.7971 9.13035 27.8985 9.37537C28 9.6204 28 9.89291 28 10.4379V20C28 23.7712 28 25.6568 26.8284 26.8284C25.6568 28 23.7712 28 20 28H12C8.22876 28 6.34315 28 5.17157 26.8284C4 25.6568 4 23.7712 4 20V12Z"
        stroke="#0075FF"
        strokeWidth="2"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 12.9406V20.9406M16 20.9406L13.3333 18.2739M16 20.9406L18.6667 18.2739M16.0836 7.69091L15.9164 7.52361C15.4552 7.06239 15.2245 6.83179 14.9555 6.66689C14.7168 6.52067 14.4567 6.41293 14.1847 6.34761C13.8777 6.27393 13.5516 6.27393 12.8994 6.27393H8.26667C6.7732 6.27393 6.02645 6.27393 5.45603 6.56458C4.95425 6.82023 4.54631 7.22818 4.29065 7.72995C4 8.30038 4 9.04711 4 10.5406V20.6739C4 22.1674 4 22.9142 4.29065 23.4846C4.54631 23.9863 4.95425 24.3943 5.45603 24.6499C6.02645 24.9406 6.77319 24.9406 8.26667 24.9406H23.7333C25.2268 24.9406 25.9736 24.9406 26.544 24.6499C27.0457 24.3943 27.4537 23.9863 27.7093 23.4846C28 22.9142 28 22.1674 28 20.6739V13.2073C28 11.7138 28 10.967 27.7093 10.3966C27.4537 9.89485 27.0457 9.4869 26.544 9.23125C25.9736 8.94059 25.2268 8.94059 23.7333 8.94059H19.1007C18.4484 8.94059 18.1223 8.94059 17.8153 8.86691C17.5433 8.80159 17.2832 8.69385 17.0445 8.54763C16.7755 8.38273 16.5448 8.15213 16.0836 7.69091Z"
        stroke="#0075FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_315_511"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_315_511)">
        <path
          d="M5.83301 17.5C5.37467 17.5 4.98231 17.3368 4.65592 17.0104C4.32954 16.684 4.16634 16.2917 4.16634 15.8333V5C3.93023 5 3.73231 4.92014 3.57259 4.76042C3.41287 4.60069 3.33301 4.40278 3.33301 4.16667C3.33301 3.93056 3.41287 3.73264 3.57259 3.57292C3.73231 3.41319 3.93023 3.33333 4.16634 3.33333H7.49967C7.49967 3.09722 7.57954 2.89931 7.73926 2.73958C7.89898 2.57986 8.0969 2.5 8.33301 2.5H11.6663C11.9025 2.5 12.1004 2.57986 12.2601 2.73958C12.4198 2.89931 12.4997 3.09722 12.4997 3.33333H15.833C16.0691 3.33333 16.267 3.41319 16.4268 3.57292C16.5865 3.73264 16.6663 3.93056 16.6663 4.16667C16.6663 4.40278 16.5865 4.60069 16.4268 4.76042C16.267 4.92014 16.0691 5 15.833 5V15.8333C15.833 16.2917 15.6698 16.684 15.3434 17.0104C15.017 17.3368 14.6247 17.5 14.1663 17.5H5.83301ZM14.1663 5H5.83301V15.8333H14.1663V5ZM8.33301 14.1667C8.56912 14.1667 8.76704 14.0868 8.92676 13.9271C9.08648 13.7674 9.16634 13.5694 9.16634 13.3333V7.5C9.16634 7.26389 9.08648 7.06597 8.92676 6.90625C8.76704 6.74653 8.56912 6.66667 8.33301 6.66667C8.0969 6.66667 7.89898 6.74653 7.73926 6.90625C7.57954 7.06597 7.49967 7.26389 7.49967 7.5V13.3333C7.49967 13.5694 7.57954 13.7674 7.73926 13.9271C7.89898 14.0868 8.0969 14.1667 8.33301 14.1667ZM11.6663 14.1667C11.9025 14.1667 12.1004 14.0868 12.2601 13.9271C12.4198 13.7674 12.4997 13.5694 12.4997 13.3333V7.5C12.4997 7.26389 12.4198 7.06597 12.2601 6.90625C12.1004 6.74653 11.9025 6.66667 11.6663 6.66667C11.4302 6.66667 11.2323 6.74653 11.0726 6.90625C10.9129 7.06597 10.833 7.26389 10.833 7.5V13.3333C10.833 13.5694 10.9129 13.7674 11.0726 13.9271C11.2323 14.0868 11.4302 14.1667 11.6663 14.1667Z"
          fill="#D43A3A"
        />
      </g>
    </svg>
  );
};
export const DeleteIconAvatar = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99984 9.33333V24C7.99984 25.4728 9.19374 26.6667 10.6665 26.6667H21.3332C22.806 26.6667 23.9998 25.4728 23.9998 24V9.33333M7.99984 9.33333H6.6665M7.99984 9.33333H10.6665M23.9998 9.33333H25.3332M23.9998 9.33333H21.3332M10.6665 9.33333V6.66667C10.6665 5.19391 11.8604 4 13.3332 4H18.6665C20.1393 4 21.3332 5.19391 21.3332 6.66667V9.33333M10.6665 9.33333H21.3332M13.3332 14.6667V21.3333M18.6665 14.6667V21.3333"
        stroke="#D53A3A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FullscreenIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_413_139)">
        <rect width="40" height="40" rx="6" fill="black" fillOpacity="0.2" />
      </g>
      <defs>
        <filter
          id="filter0_b_413_139"
          x="-10"
          y="-10"
          width="60"
          height="60"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_413_139"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_413_139"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ResetIcon = () => {
  return (
    <svg
      fill="#000000"
      height="16px"
      width="16px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 489.698 489.698"
    >
      <g>
        <g>
          <path
            d="M468.999,227.774c-11.4,0-20.8,8.3-20.8,19.8c-1,74.9-44.2,142.6-110.3,178.9c-99.6,54.7-216,5.6-260.6-61l62.9,13.1
			c10.4,2.1,21.8-4.2,23.9-15.6c2.1-10.4-4.2-21.8-15.6-23.9l-123.7-26c-7.2-1.7-26.1,3.5-23.9,22.9l15.6,124.8
			c1,10.4,9.4,17.7,19.8,17.7c15.5,0,21.8-11.4,20.8-22.9l-7.3-60.9c101.1,121.3,229.4,104.4,306.8,69.3
			c80.1-42.7,131.1-124.8,132.1-215.4C488.799,237.174,480.399,227.774,468.999,227.774z"
          />
          <path
            d="M20.599,261.874c11.4,0,20.8-8.3,20.8-19.8c1-74.9,44.2-142.6,110.3-178.9c99.6-54.7,216-5.6,260.6,61l-62.9-13.1
			c-10.4-2.1-21.8,4.2-23.9,15.6c-2.1,10.4,4.2,21.8,15.6,23.9l123.8,26c7.2,1.7,26.1-3.5,23.9-22.9l-15.6-124.8
			c-1-10.4-9.4-17.7-19.8-17.7c-15.5,0-21.8,11.4-20.8,22.9l7.2,60.9c-101.1-121.2-229.4-104.4-306.8-69.2
			c-80.1,42.6-131.1,124.8-132.2,215.3C0.799,252.574,9.199,261.874,20.599,261.874z"
          />
        </g>
      </g>
    </svg>
  );
};

export const PlusIconBg = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.7895 30.2105V39.7895C25.7895 40.4158 26.0015 40.9408 26.4253 41.3644C26.8492 41.7881 27.3744 42 28.001 42C28.6276 42 29.1525 41.7881 29.5757 41.3644C29.9989 40.9408 30.2105 40.4158 30.2105 39.7895V30.2105H39.7895C40.4158 30.2105 40.9408 29.9985 41.3645 29.5747C41.7881 29.1508 42 28.6256 42 27.999C42 27.3724 41.7881 26.8475 41.3645 26.4243C40.9408 26.0011 40.4158 25.7895 39.7895 25.7895H30.2105V16.2105C30.2105 15.5842 29.9985 15.0592 29.5747 14.6355C29.1508 14.2119 28.6256 14 27.999 14C27.3724 14 26.8475 14.2119 26.4243 14.6355C26.0011 15.0592 25.7895 15.5842 25.7895 16.2105V25.7895H16.2105C15.5842 25.7895 15.0592 26.0015 14.6356 26.4253C14.2119 26.8492 14 27.3744 14 28.001C14 28.6276 14.2119 29.1525 14.6356 29.5757C15.0592 29.9989 15.5842 30.2105 16.2105 30.2105H25.7895ZM28.0049 56C24.1323 56 20.4922 55.2651 17.0846 53.7954C13.677 52.3256 10.7129 50.331 8.19223 47.8115C5.67154 45.2919 3.67599 42.3291 2.2056 38.923C0.735199 35.5169 0 31.8776 0 28.0049C0 24.1323 0.734879 20.4922 2.20464 17.0846C3.6744 13.677 5.66903 10.7129 8.18855 8.19224C10.7081 5.67154 13.6709 3.676 17.077 2.2056C20.4831 0.735202 24.1224 0 27.9951 0C31.8677 0 35.5078 0.734882 38.9154 2.20464C42.323 3.6744 45.2871 5.66903 47.8078 8.18855C50.3285 10.7081 52.324 13.6709 53.7944 17.077C55.2648 20.4831 56 24.1224 56 27.9951C56 31.8677 55.2651 35.5078 53.7954 38.9154C52.3256 42.323 50.331 45.2871 47.8115 47.8078C45.2919 50.3285 42.3291 52.324 38.923 53.7944C35.5169 55.2648 31.8776 56 28.0049 56Z"
        fill="#FA5711"
      />
    </svg>
  );
};

export const DropdownIcon = () => {
  return (
    <svg
      width="8"
      height="5"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.56234 4.06254L0.541504 1.04171C0.499837 1.00004 0.468587 0.954902 0.447754 0.906291C0.426921 0.85768 0.416504 0.805596 0.416504 0.750041C0.416504 0.63893 0.454698 0.541707 0.531087 0.458374C0.607476 0.375041 0.708171 0.333374 0.833171 0.333374H7.1665C7.2915 0.333374 7.3922 0.375041 7.46859 0.458374C7.54498 0.541707 7.58317 0.63893 7.58317 0.750041C7.58317 0.777819 7.5415 0.875041 7.45817 1.04171L4.43734 4.06254C4.36789 4.13199 4.29845 4.1806 4.229 4.20837C4.15956 4.23615 4.08317 4.25004 3.99984 4.25004C3.9165 4.25004 3.84012 4.23615 3.77067 4.20837C3.70123 4.1806 3.63178 4.13199 3.56234 4.06254Z"
        fill="#1C1B1F"
      />
    </svg>
  );
};
